"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MapOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var MapOutlineSVG = function MapOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M28,3.88a2.16,2.16,0,0,0-.7.13l-6,1.9a1,1,0,0,1-.58,0L11.25,3.07a1.21,1.21,0,0,0-.5,0L3.51,4.62A2,2,0,0,0,2,6.56V25.44a2,2,0,0,0,2,2,2.12,2.12,0,0,0,.49-.06l6.26-1.33a1.16,1.16,0,0,1,.49,0l9.46,2.84a1,1,0,0,0,.6,0l7.4-2.41A2,2,0,0,0,30,24.61V5.89A2,2,0,0,0,28,3.88ZM12,5.3l8,2.4v19l-8-2.4ZM4,25.44V6.56l6-1.34v19Zm24-.83-6,2.05V7.7l6-1.81Z"
  }));
};
exports.MapOutlineSVG = MapOutlineSVG;
MapOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(MapOutlineSVG);
exports.default = _default;